import {isNotUndefinedAndNotNull} from "@/utils/classes";

export default {
  getUserPermissions: (state) => state.permissions,
  isValidPermission: (state) => (permission) => {
    return isNotUndefinedAndNotNull(state.permissions.find(el => el === permission));
  },
}
